import BaseProxy from "../../base-proxy";

/**
 * @class UserCompanyUsersProxy
 * @description All endpoints related to company users of a user regardless of companies
 * @author Victor
 * @version 1.0
 * @since January 21, 2020
 */
export default {
  async getUserCompanyUsers(input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/users/${input.userId}/company-users/`;

    return await baseProxy.getAuthenticatedData(endpointUrl, input.authToken);
  },
};
